<template>
    <ContainerXxl>
        <Breadcrumbs :h1="true"/>

        <div class="page_glossary">
            <GlossaryAlphabet :letters="page.letters"/>
            <hr>

            <slot/>
        </div>
    </ContainerXxl>
</template>

<script setup>
const ContainerXxl = defineAsyncComponent(() => import('~/layouts/container-xxl.vue'));

defineProps({
    page: Object
});
</script>
